exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-row:hover, .selected-row {\r\n    background-color: #CFD8DC;\r\n    cursor: pointer;\r\n  }\r\n\r\n.lod {\r\n    padding: 25px;\r\n  }\r\n\r\n.mat-header-row {\r\n  font-size: 125%;\r\n}\r\n\r\n.list-padding {\r\n  margin-left:125px;\r\n  padding-top:15px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();